export default `
fragment ParagraphVideoSharepoint on ParagraphVideoSharepoint {
  id
  uuid
  entityBundle
  title
  description {
    value
  }
  sharepoint_urls
}
`
